// polling for data
// flattening data (match ID: {actions...}, match ID 2: {actions...}) not needed ..get_match?match=<?= $match['match_id']; ?>
// for matchID current page - hub-update-events


import {updateHubUI} from "./hub-update-events.js";

let updatedData = {};
//let lastFlatData = {};

export async function pollHub(eventsDataUrl, interval = 20000) {
    console.log('AJAX HUB POLL called ===============================');
    let testDataUrl = 'https://gong2025.ni.bg:4433/webpack/src/pages-assets/hub/data/events_update.json';
    
    let lastData = [];

    setInterval(async () => {
        try {
            //console.log('Last data:', lastData);
            
            const response = await fetch(eventsDataUrl);
            //const response = await fetch(testDataUrl);
            const data = await response.json();
            
//            console.log('New data:', data);
//            console.log('New data !== Last data', JSON.stringify(data) !== JSON.stringify(lastData), JSON.stringify(data), JSON.stringify(lastData));
            
            if (JSON.stringify(data) !== JSON.stringify(lastData)) {

                //updatedData = selectUpdatedEvents(data[0]); 
                console.log('Updated data:', updatedData);
//
                updateHubUI(selectUpdatedEvents(data[0]));
//                updateHubUI(updatedData);
//                updateHubUI(data);
//
                lastData = data;
//
            } else {
                console.log('No change');
            }

        } catch (err) {
            console.error('Polling error:', err);
        }
    }, interval);
}

function selectUpdatedEvents(dataObj) {
    Object.keys(dataObj).forEach(key => {
        console.log(key, dataObj[key],  dataObj[key]['eventData']);
        if (dataObj[key]['eventData'] != null) {
            updatedData[key] = dataObj[key];
        }
    });
    
    return updatedData;
}